import type { ValidationErrorBody } from '@/js/types/http';
import axios, { type AxiosError } from 'axios';

export function isValidationError(
  error: unknown,
): error is AxiosError<ValidationErrorBody> {
  return axios.isAxiosError(error) && error.response?.status === 422;
}
